<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t("etiquetas") }}</li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <!-- El negocio y las tres cifras, en la misma linea y dentro de una `card`, como
             la cabecera del listado de productos. El titulo y el rastro de migas ya dicen
             donde estas, asi que no hace falta repetirlo. -->
        <div class="card">
          <div class="ficha-superior">
            <div class="campo-negocio">
            <label>{{ $t("negocio") }}</label>
            <el-select
              class="select-default"
              size="large"
              v-model="idBusiness"
              filterable
              :placeholder="$t('seleccionaNegocio')"
              @change="cargar()"
            >
              <el-option
                v-for="business in listBusinesses"
                class="select-primary"
                :value="business.id"
                :label="business.establishmentName"
                :key="business.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="ficha-resumen" v-if="cargado">
            <div class="ficha-dato">
              <b>{{ conteo.A }}</b>
              <span>{{ $t("deMateriaPrima") }}</span>
            </div>
            <div class="ficha-dato">
              <b>{{ conteo.P }}</b>
              <span>{{ $t("deProveedor") }}</span>
            </div>
            <div class="ficha-dato" :class="{ ojo: conteo.problema > 0 }">
              <b>{{ conteo.problema }}</b>
              <span>{{ $t("conProblema") }}</span>
            </div>
            </div>
          </div>
        </div>

        <template v-if="cargado">
          <!-- Avisos. De momento solo cuentan lo que pasa; arreglarlo viene despues. -->
          <div class="avisos" v-if="avisos.length">
            <div v-for="(aviso, i) in avisos" :key="'av' + i" class="aviso" :class="{ rojo: aviso.rojo }">
              <span class="aviso-ico">{{ aviso.rojo ? "!" : "⚠" }}</span>
              <p v-html="aviso.texto"></p>
              <!-- Los avisos que se arreglan asignando una etiqueta llevan la salida al
                   lado del problema. Los de etiquetas ocultas o sin tipo no: ahi lo que
                   hay que tocar es el arbol, no la ficha de la materia prima. -->
              <button
                type="button"
                class="aviso-btn"
                v-if="aviso.motivo"
                @click="abrirRevision(aviso.motivo)"
              >
                {{ $t("verYAsignar") }}
              </button>
              <!-- El de las etiquetas sin familia no recoloca materias primas: les pone
                   la familia que les falta, que es lo que devuelve su rama al panel. -->
              <button
                type="button"
                class="aviso-btn"
                v-else-if="aviso.sinTipo"
                @click="abrirSinTipo()"
              >
                {{ $t("asignarFamilia") }}
              </button>
            </div>
          </div>

          <!-- Las dos familias no se mezclan: son dos cosas distintas y el usuario tiene
               que verlas separadas. La pestana de sin tipo solo aparece si hay alguna. -->
          <nav class="arb-barra" :aria-label="$t('familiasDeEtiquetas')">
            <button type="button" :aria-current="vista === 'A' ? 'true' : 'false'" @click="vista = 'A'">
              {{ $t("materiasPrimas") }}
              <span class="cnt">{{ conteo.A }}</span>
            </button>
            <button type="button" :aria-current="vista === 'P' ? 'true' : 'false'" @click="vista = 'P'">
              {{ $t("proveedores") }}
              <span class="cnt">{{ conteo.P }}</span>
            </button>
            <button
              v-if="conteo.X"
              type="button"
              :aria-current="vista === 'X' ? 'true' : 'false'"
              @click="vista = 'X'"
            >
              {{ $t("sinTipo") }}
              <span class="cnt">{{ conteo.X }}</span>
            </button>
            <button type="button" :aria-current="vista === 'todas' ? 'true' : 'false'" @click="vista = 'todas'">
              {{ $t("verTodas") }}
            </button>

            <!-- Excluyente, como en la pantalla de siempre: sin marcar se ven las activas,
                 marcada se ven SOLO las de baja. Va apagada y en pequeno porque filtra lo
                 que se mira, no es una accion. -->
            <label class="chk-baja" :class="{ puesto: isDeBaja }">
              <input type="checkbox" v-model="isDeBaja" />
              {{ $t("buscarEtiquetasBaja") }}
            </label>

            <span class="sep"></span>

            <!-- El recuento solo sale mientras se busca: las pestanas siguen contando la
                 familia entera, y sin esta linea parecerian estar equivocadas. -->
            <span class="busc">
              <i class="fa fa-search"></i>
              <input type="text" v-model="busqueda" :placeholder="$t('buscar')" :aria-label="$t('buscar')" />
              <button
                v-if="busqueda"
                type="button"
                class="busc-x"
                :title="$t('cancelar')"
                :aria-label="$t('cancelar')"
                @click="busqueda = ''"
              >
                <i class="fa fa-times"></i>
              </button>
            </span>
            <span class="busc-cuenta" v-if="busqueda">{{ visibles.length }} / {{ enFamilia.length }}</span>

            <button type="button" class="btn-nueva" @click="abrirAlta()">
              <i class="fa fa-plus"></i>{{ $t("nuevaEtiqueta") }}
            </button>
          </nav>

          <div class="sector-card">
            <table class="sector-tabla" v-if="visibles.length">
              <thead>
                <tr>
                  <th>{{ $t("etiqueta") }}</th>
                  <!-- El tipo va antes que el padre: asi la columna que aparece y
                       desaparece al cambiar de pestana queda pegada al nombre, y no
                       entre dos columnas que si estan siempre. -->
                  <th class="tipo" v-if="vista === 'todas'">{{ $t("tipo") }}</th>
                  <th class="padre">{{ $t("etiquetaPadre") }}</th>
                  <th class="num">{{ $t("materiasPrimas") }}</th>
                  <th class="acc">{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tag in visibles" :key="'t' + tag.id" :class="{ rota: !esSana(tag) }">
                  <td>
                    <span class="cat-nombre">{{ tag.nombre || $t("sinNombre") }}</span>
                    <span class="cat-estado" :class="estadoDe(tag).clase">{{ estadoDe(tag).texto }}</span>
                  </td>
                  <td class="tipo" v-if="vista === 'todas'">{{ nombreTipo(tag.tipo) }}</td>
                  <td class="padre">
                    <span v-if="tag.nombrePadre">{{ tag.nombrePadre }}</span>
                    <span v-else-if="tag.parentCode" class="padre-roto">
                      {{ $t("padreCode", { code: tag.parentCode }) }}
                    </span>
                    <span v-else class="padre-ninguno">—</span>
                  </td>
                  <td class="num">{{ tag.materiasPrimas }}</td>
                  <td class="acc">
                    <button
                      type="button"
                      class="arb-btn arb-btn-editar"
                      :title="$t('editar')"
                      :aria-label="$t('editar')"
                      :disabled="guardando"
                      @click="abrirEdicion(tag)"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      type="button"
                      class="arb-btn"
                      :class="tag.baja ? 'arb-btn-ver' : 'arb-btn-borrar'"
                      :title="tag.baja ? $t('reactivar') : $t('darDeBaja')"
                      :aria-label="tag.baja ? $t('reactivar') : $t('darDeBaja')"
                      :disabled="guardando"
                      @click="cambiarBaja(tag)"
                    >
                      <i class="fa" :class="tag.baja ? 'fa-undo' : 'fa-ban'"></i>
                    </button>
                  </td>
                </tr>

                <!-- Las materias primas sin etiqueta no son una etiqueta, pero es donde el
                     usuario las busca: van al final, como en la pantalla de categorias. -->
                <tr v-if="vista !== 'P' && resumen.materiasPrimasSinEtiqueta" class="sin-cat">
                  <td>
                    <span class="cat-nombre">{{ $t("sinEtiqueta") }}</span>
                    <span class="cat-estado warn">{{ $t("sinEtiquetaExplica") }}</span>
                  </td>
                  <td class="tipo" v-if="vista === 'todas'">—</td>
                  <td class="padre"></td>
                  <td class="num">{{ resumen.materiasPrimasSinEtiqueta }}</td>
                  <td class="acc"></td>
                </tr>
              </tbody>
            </table>

            <p class="vacio" v-else>{{ $t("sinEtiquetasEnEstaFamilia") }}</p>
          </div>

          <p class="foot">{{ $t("notaEtiquetas") }}</p>
        </template>
      </div>
    </div>

    <etiqueta-nueva-modal
      ref="modalEtiqueta"
      :id-business="idBusiness"
      :ocupado="guardando"
      @confirmar="guardarEtiqueta"
    />

    <materias-primas-revisar-modal
      ref="modalRevisar"
      :id-business="idBusiness"
      :etiquetas="etiquetas"
      @asignado="materiasAsignadas"
    />

    <etiqueta-baja-modal
      ref="modalBaja"
      :etiquetas="etiquetas"
      :ocupado="guardando"
      @confirmar="bajaConfirmada"
    />

    <etiquetas-sin-tipo-modal
      ref="modalSinTipo"
      :etiquetas="etiquetas"
      :ocupado="guardando"
      @confirmar="asignarFamilia"
    />
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Loading } from "element-ui";
import { Select, Option } from "element-ui";
import EtiquetaNuevaModal from "../../../Widgets/Etiquetas/EtiquetaNuevaModal.vue";
import MateriasPrimasRevisarModal from "../../../Widgets/Etiquetas/MateriasPrimasRevisarModal.vue";
import EtiquetaBajaModal from "../../../Widgets/Etiquetas/EtiquetaBajaModal.vue";
import EtiquetasSinTipoModal from "../../../Widgets/Etiquetas/EtiquetasSinTipoModal.vue";

export default {
  created() {
    this.$store.dispatch("setNameRoute", this.$i18n.t("etiquetas"));

    if (this.$store.getters.idBusiness) {
      this.idBusiness = this.$store.getters.idBusiness;
    }

    this.getBusiness();
  },

  data() {
    return {
      loadingGeneral: null,
      cargado: false,

      listBusinesses: [],
      idBusiness: this.$route.params.idBusiness,

      etiquetas: [],
      resumen: {
        total: 0,
        materiaPrima: 0,
        proveedor: 0,
        sinTipo: 0,
        huerfanas: 0,
        ocultas: 0,
        conProblema: 0,
        materiasPrimasOcultas: 0,
        materiasPrimasConEtiquetaProveedor: 0,
        materiasPrimasConEtiquetaSinTipo: 0,
        materiasPrimasSinEtiqueta: 0,
        materiasPrimasConEtiquetaDeBaja: 0,
        materiasPrimasConEtiquetaInexistente: 0,
        nombresRepetidos: [],
        ocultaDestacada: ""
      },

      vista: "A",
      isDeBaja: false,
      busqueda: "",

      guardando: false
    };
  },

  computed: {
    /**
     * Las etiquetas del lado de la casilla. La casilla es excluyente, no aditiva: sin
     * marcar se ven las activas, marcada se ven SOLO las de baja. Es lo mismo que hace la
     * pantalla de siempre, que vuelve a pedirlas a la API con `baja = 0` o `baja = 1`.
     */
    enEstado() {
      let baja = this.isDeBaja ? 1 : 0;

      return this.etiquetas.filter(t => t.baja === baja);
    },

    /**
     * Los contadores van sobre lo que se esta viendo, no sobre el total: si la pestana
     * dice 53 y la tabla ensena 48, la que se equivoca es la pestana.
     */
    conteo() {
      let cuenta = { A: 0, P: 0, X: 0, problema: 0 };
      let vm = this;

      this.enEstado.forEach(function(t) {
        if (t.tipo === "A") {
          cuenta.A++;
        } else if (t.tipo === "P") {
          cuenta.P++;
        } else {
          cuenta.X++;
        }

        if (!vm.esSana(t)) {
          cuenta.problema++;
        }
      });

      return cuenta;
    },

    /**
     * Las de la pestana elegida, sin aplicar todavia la busqueda. Se separa para poder
     * decir "3 de 53" sin recalcular el filtro dos veces.
     */
    enFamilia() {
      if (this.vista === "A" || this.vista === "P") {
        return this.enEstado.filter(t => t.tipo === this.vista);
      }

      if (this.vista === "X") {
        return this.enEstado.filter(t => t.tipo !== "A" && t.tipo !== "P");
      }

      return this.enEstado;
    },

    visibles() {
      let lista = this.enFamilia;
      let texto = this.normalizar(this.busqueda);

      if (texto) {
        // Tambien por la ruta: con cinco "MENAJE" en el mismo negocio, buscar por la rama
        // es a veces la unica forma de dar con la que se quiere.
        lista = lista.filter(t => {
          return (
            this.normalizar(t.nombre).indexOf(texto) !== -1 ||
            this.normalizar(t.ruta).indexOf(texto) !== -1
          );
        });
      }

      // Lo roto primero: si la pantalla existe para ensenar lo que falla, no tiene
      // sentido que haya que bajar cincuenta filas para encontrarlo.
      let vm = this;

      return lista.slice().sort(function(a, b) {
        let sanaA = vm.esSana(a) ? 1 : 0;
        let sanaB = vm.esSana(b) ? 1 : 0;

        if (sanaA !== sanaB) {
          return sanaA - sanaB;
        }

        if (a.materiasPrimas !== b.materiasPrimas) {
          return b.materiasPrimas - a.materiasPrimas;
        }

        return (a.nombre || "").localeCompare(b.nombre || "");
      });
    },

    /**
     * Los avisos de arriba. De momento solo informan: arreglarlos es el paso siguiente.
     */
    avisos() {
      let lista = [];
      let r = this.resumen;

      if (r.ocultas) {
        lista.push({
          rojo: true,
          texto: this.$tc("avisoEtiquetasOcultas", r.ocultas, {
            n: r.ocultas,
            m: r.materiasPrimasOcultas,
            nombre: r.ocultaDestacada
          })
        });
      }

      if (r.materiasPrimasConEtiquetaProveedor) {
        lista.push({
          rojo: true,
          motivo: "etiquetaProveedor",
          texto: this.$tc("avisoMpConEtiquetaProveedor", r.materiasPrimasConEtiquetaProveedor, {
            n: r.materiasPrimasConEtiquetaProveedor
          })
        });
      }

      if (r.materiasPrimasConEtiquetaSinTipo) {
        lista.push({
          rojo: true,
          motivo: "etiquetaSinTipo",
          texto: this.$tc("avisoMpConEtiquetaSinTipo", r.materiasPrimasConEtiquetaSinTipo, {
            n: r.materiasPrimasConEtiquetaSinTipo
          })
        });
      }

      // Materias primas atrapadas en una etiqueta de baja: la etiqueta existe, pero la
      // ficha ya no la ofrece, asi que sin este modal no habia forma de sacarlas de ahi.
      if (r.materiasPrimasConEtiquetaDeBaja) {
        lista.push({
          rojo: true,
          motivo: "etiquetaDeBaja",
          texto: this.$tc("avisoMpConEtiquetaDeBaja", r.materiasPrimasConEtiquetaDeBaja, {
            n: r.materiasPrimasConEtiquetaDeBaja
          })
        });
      }

      // Referencia rota: `tags` es MyISAM y no tiene clave ajena que lo impida.
      if (r.materiasPrimasConEtiquetaInexistente) {
        lista.push({
          rojo: true,
          motivo: "etiquetaInexistente",
          texto: this.$tc("avisoMpConEtiquetaInexistente", r.materiasPrimasConEtiquetaInexistente, {
            n: r.materiasPrimasConEtiquetaInexistente
          })
        });
      }

      // En rojo y no en ambar: una etiqueta sin familia no solo no se ve ella, corta
      // la rama y esconde todo lo que cuelga. En el 6730 una sola escondia 34.
      if (r.sinTipo) {
        lista.push({
          rojo: true,
          sinTipo: true,
          texto: this.$tc("avisoEtiquetasSinTipo", r.sinTipo, { n: r.sinTipo })
        });
      }

      if (r.materiasPrimasSinEtiqueta) {
        lista.push({
          rojo: false,
          motivo: "sinEtiqueta",
          texto: this.$tc("avisoMpSinEtiqueta", r.materiasPrimasSinEtiqueta, {
            n: r.materiasPrimasSinEtiqueta
          })
        });
      }

      let vm = this;

      (r.nombresRepetidos || []).forEach(function(rep) {
        lista.push({
          rojo: false,
          texto: vm.$t("avisoEtiquetaRepetida", {
            n: rep.veces,
            nombre: rep.nombre,
            familia: vm.nombreTipo(rep.tipo)
          })
        });
      });

      return lista;
    }
  },

  methods: {
    getBusiness() {
      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (response.data.response) {
            if (!vm.idBusiness) {
              vm.idBusiness = response.data.result[0].id;
            }

            vm.listBusinesses = response.data.result;
            vm.cargar();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    cargar() {
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      this.$store.dispatch("setIdBusiness", this.idBusiness);

      var config = {
        params: { idBusiness: this.idBusiness, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "categories/getBusinessTags", config)
        .then(function(response) {
          vm.loadingGeneral.close();

          if (!response.data.response) {
            vm.cargado = false;
            return;
          }

          vm.etiquetas = response.data.result.etiquetas;
          vm.resumen = response.data.result.resumen;
          vm.cargado = true;
        })
        .catch(function(error) {
          vm.loadingGeneral.close();
          console.log(error);
        });
    },

    /**
     * Minusculas y sin tildes: se busca "alimentacion" y aparece "Alimentación".
     */
    normalizar(texto) {
      return (texto || "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },

    abrirAlta() {
      // La familia que se ofrece es la que se esta mirando, que es casi siempre la que se
      // quiere. En "todas" y en "sin tipo" no hay pista, asi que se parte de materia prima.
      this.$refs.modalEtiqueta.abrir(this.vista === "P" ? "P" : "A");
    },

    abrirEdicion(tag) {
      this.$refs.modalEtiqueta.abrirEdicion(tag);
    },

    abrirRevision(motivo) {
      this.$refs.modalRevisar.abrir(motivo);
    },

    abrirSinTipo() {
      this.$refs.modalSinTipo.abrir();
    },

    /**
     * Poner la familia devuelve al panel la rama entera que colgaba de esa etiqueta, asi
     * que hay que recargar: cambian las cifras, los avisos y que etiquetas son alcanzables.
     */
    asignarFamilia(datos) {
      if (this.guardando) {
        return;
      }

      this.guardando = true;

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = {
        idBusiness: this.idBusiness,
        type: datos.type,
        ids: datos.ids,
        jwt: this.$store.getters.jwt
      };

      let vm = this;

      this.axios
        .post(this.$store.getters.apiUrl + "categories/setBusinessTagsTipo", params, config)
        .then(function(response) {
          vm.guardando = false;

          if (!response.data.response) {
            vm.$refs.modalSinTipo.mostrarError(response.data.message);
            return;
          }

          vm.$refs.modalSinTipo.cerrar();
          vm.$notify({
            message: vm.$tc("familiaAsignada", response.data.result.actualizadas, {
              n: response.data.result.actualizadas
            }),
            icon: "nc-icon nc-check-2",
            timeout: 2500,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });

          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          vm.$refs.modalSinTipo.mostrarError(vm.$t("errorInesperado"));
          console.log(error);
        });
    },

    /**
     * Que se dice al terminar. Interesa lo que se ha movido, no solo que la etiqueta
     * quedo de baja: es el dato que el usuario no puede ver en la tabla.
     */
    mensajeDeBaja(baja, resultado) {
      if (!baja) {
        return this.$t("etiquetaReactivada");
      }

      let partes = [this.$t("etiquetaDadaDeBaja")];

      if (resultado.reasignadas) {
        partes.push(
          resultado.idTagDestino
            ? this.$tc("bajaMpReasignadas", resultado.reasignadas, { n: resultado.reasignadas })
            : this.$tc("bajaMpSinEtiqueta", resultado.reasignadas, { n: resultado.reasignadas })
        );
      }

      if (resultado.hijasMovidas) {
        partes.push(this.$tc("bajaHijasMovidas", resultado.hijasMovidas, { n: resultado.hijasMovidas }));
      }

      return partes.join(" ");
    },

    /**
     * Tras recolocar hay que volver a pedir las etiquetas: cambian los contadores de
     * materias primas por etiqueta y, con ellos, los avisos de arriba.
     */
    materiasAsignadas(cuantas) {
      this.cargar();

      this.$notify({
        message: this.$tc("materiasPrimasAsignadas", cuantas, { n: cuantas }),
        icon: "nc-icon nc-check-2",
        timeout: 2500,
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success"
      });
    },

    /**
     * Alta y edicion salen del mismo modal, asi que llegan por el mismo sitio. Lo unico
     * que cambia es a que endpoint van y que se hace despues.
     */
    guardarEtiqueta(etiqueta) {
      if (this.guardando) {
        return;
      }

      this.guardando = true;

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = {
        idBusiness: this.idBusiness,
        tag: etiqueta,
        jwt: this.$store.getters.jwt
      };

      let ruta = etiqueta.editando ? "updateBusinessTag" : "createBusinessTag";
      let vm = this;

      this.axios
        .post(this.$store.getters.apiUrl + "categories/" + ruta, params, config)
        .then(function(response) {
          vm.guardando = false;

          if (!response.data.response) {
            vm.$refs.modalEtiqueta.mostrarError(response.data.message);
            return;
          }

          vm.$refs.modalEtiqueta.cerrar();
          vm.$notify({
            message: etiqueta.editando ? vm.$t("etiquetaGuardada") : vm.$t("etiquetaCreada"),
            icon: "nc-icon nc-check-2",
            timeout: 2000,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });

          if (!etiqueta.editando) {
            // Se nace activa, asi que si se estaba mirando la lista de bajas no se veria.
            vm.isDeBaja = false;
            vm.vista = etiqueta.type;
          }

          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          vm.$refs.modalEtiqueta.mostrarError(vm.$t("noSeHaPodidoGuardar"));
          console.log(error);
        });
    },

    /**
     * Da de baja una etiqueta, o la reactiva.
     *
     * Antes de dar de baja se dice lo que se lleva por delante: las materias primas que
     * la tienen puesta se quedan apuntando a una etiqueta de baja, y las etiquetas que
     * cuelgan de ella se quedan sin padre valido. Las dos cosas son reversibles -no se
     * borra nada- pero el usuario deberia enterarse antes, no despues.
     */
    /**
     * Reactivar es inmediato: la etiqueta vuelve y lo que tenia dentro sigue en su sitio.
     * Dar de baja pasa por el modal, que es donde se dice a donde van sus materias primas.
     */
    cambiarBaja(tag) {
      if (this.guardando) {
        return;
      }

      if (tag.baja) {
        this.aplicarBaja(tag, 0, -1);
        return;
      }

      this.$refs.modalBaja.abrir(tag);
    },

    bajaConfirmada(datos) {
      this.aplicarBaja({ id: datos.idTag }, 1, datos.idTagDestino);
    },

    aplicarBaja(tag, baja, idTagDestino) {
      this.guardando = true;

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = {
        idBusiness: this.idBusiness,
        idTag: tag.id,
        baja: baja,
        idTagDestino: idTagDestino,
        jwt: this.$store.getters.jwt
      };

      let vm = this;

      this.axios
        .post(this.$store.getters.apiUrl + "categories/setBusinessTagBaja", params, config)
        .then(function(response) {
          vm.guardando = false;

          // El error de la baja se ensena dentro del modal, que es donde esta mirando el
          // usuario y donde puede corregir el destino sin volver a empezar.
          if (!response.data.response) {
            if (baja) {
              vm.$refs.modalBaja.mostrarError(response.data.message);
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error"
              });
            }
            return;
          }

          if (baja) {
            vm.$refs.modalBaja.cerrar();
          }

          vm.$notify({
            message: vm.mensajeDeBaja(baja, response.data.result),
            icon: "nc-icon nc-check-2",
            timeout: 3000,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });

          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          swal({
            title: vm.$t("atencion"),
            text: vm.$t("noSeHaPodidoGuardar"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error"
          });
          console.log(error);
        });
    },

    /**
     * Una etiqueta esta sana si tiene tipo, su sitio en el arbol se sostiene y el resto
     * del panel la ensena. `alcanzable` es lo que decide esto ultimo: las pantallas
     * viejas bajan desde las raices, asi que lo que no se alcanza no existe para ellas.
     */
    esSana(tag) {
      return tag.estado === "ok" && tag.alcanzable && !tag.nombreRepetido;
    },

    /**
     * El estado dicho en castellano, que es una frase y no un dato, y por eso va debajo
     * del nombre y no en una columna.
     */
    estadoDe(tag) {
      if (tag.tipo !== "A" && tag.tipo !== "P") {
        return { clase: "mal", texto: this.$t("estadoSinTipo") };
      }

      if (tag.estado === "bucle") {
        return { clase: "mal", texto: this.$t("estadoBucle") };
      }

      if (tag.estado === "huerfana") {
        return { clase: "mal", texto: this.$t("estadoHuerfana", { code: tag.parentCode }) };
      }

      if (!tag.alcanzable) {
        return { clase: "mal", texto: this.$t("estadoNoSeVe") };
      }

      // Con la casilla marcada todas las de la tabla estan de baja, asi que decirlo en
      // cada fila seria ruido: solo se dice cuando aparece donde no tocaria.
      if (tag.baja && !this.isDeBaja) {
        return { clase: "warn", texto: this.$t("estadoDeBaja") };
      }

      if (tag.nombreRepetido) {
        return { clase: "warn", texto: this.$t("estadoNombreRepetido") };
      }

      if (tag.nivel > 1) {
        return { clase: "ok", texto: this.$t("estadoDentroDe", { padre: tag.nombrePadre }) };
      }

      return { clase: "ok", texto: this.$t("estadoRaiz") };
    },

    nombreTipo(tipo) {
      if (tipo === "A") {
        return this.$t("materiaPrima");
      }

      if (tipo === "P") {
        return this.$t("proveedor");
      }

      return this.$t("sinTipo");
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    EtiquetaNuevaModal,
    MateriasPrimasRevisarModal,
    EtiquetaBajaModal,
    EtiquetasSinTipoModal
  }
};
</script>

<style scoped>
/* ---------------------------------------------------------------------------
   Etiquetas de un negocio.

   Las clases replican las de CategoriasNegocio.vue y SectorProduct.vue a
   proposito: es la misma familia visual. Estan duplicadas porque los estilos con
   scope no cruzan de un componente a otro.
   --------------------------------------------------------------------------- */
/* Mismo relleno que la cabecera del listado de productos, que tambien se lo pone
   por su cuenta: la `card` del tema no trae ninguno. */
.card {
    padding: 20px;
}

/* El selector a la izquierda y las cifras a la derecha, alineados por abajo para
   que la caja del desplegable quede a la altura de las tarjetas. El margen de
   abajo lo pone ya la `card`. */
.ficha-superior {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
}

.ficha-resumen {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.ficha-dato {
    background: #fff;
    border: 1px solid #e6e9ef;
    border-radius: 4px;
    padding: 8px 14px;
    text-align: center;
    min-width: 100px;
}

.ficha-dato b {
    display: block;
    font-size: 1.25em;
    line-height: 1.1;
    font-variant-numeric: tabular-nums;
}

.ficha-dato span {
    font-size: 0.72em;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #8b96a3;
}

/* La cifra de etiquetas con problema solo se tine cuando hay alguna. */
.ficha-dato.ojo {
    background: rgba(214, 158, 46, 0.09);
    border-color: rgba(214, 158, 46, 0.25);
}

.ficha-dato.ojo b,
.ficha-dato.ojo span {
    color: #96690f;
}

.sector-card {
    border: 1px solid #e6e9ef;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    margin-bottom: 16px;
}

/* Corto: es un desplegable de un solo dato, y a ancho completo parecia el
   contenido de la pantalla en vez de un filtro. */
.campo-negocio {
    flex: 0 1 340px;
    min-width: 220px;
}

.campo-negocio label {
    display: block;
    font-size: 0.74em;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #8b96a3;
    font-weight: 600;
    margin-bottom: 6px;
}

.campo-negocio .el-select {
    width: 100%;
}

/* ---- Avisos ---- */
.avisos {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
}

.aviso {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 11px 14px;
    border-radius: 4px;
    background: rgba(214, 158, 46, 0.09);
    border: 1px solid rgba(214, 158, 46, 0.25);
}

.aviso.rojo {
    background: rgba(161, 58, 47, 0.1);
    border-color: rgba(161, 58, 47, 0.22);
}

.aviso p {
    flex: 1 1 320px;
    margin: 0;
    font-size: 0.88em;
    color: #3d4a58;
}

/* Al final del aviso, no en medio del texto: se lee el problema y la salida esta
   donde acaba la frase. Hereda el color del propio aviso para no parecer un boton
   ajeno pegado encima. */
.aviso-btn {
    flex: 0 0 auto;
    margin-left: auto;
    border: 1px solid rgba(138, 100, 32, 0.45);
    background: rgba(255, 255, 255, 0.55);
    border-radius: 3px;
    padding: 5px 11px;
    font-size: 0.82em;
    font-weight: 600;
    color: #8a6420;
    white-space: nowrap;
}

.aviso-btn:hover {
    background: #fff;
    border-color: #8a6420;
}

.aviso.rojo .aviso-btn {
    border-color: rgba(161, 58, 47, 0.4);
    color: #a13a2f;
}

.aviso.rojo .aviso-btn:hover {
    border-color: #a13a2f;
}

.aviso-ico {
    flex: 0 0 auto;
    font-weight: 700;
    color: #96690f;
}

.aviso.rojo .aviso-ico {
    color: #a13a2f;
}

/* ---- Barra de familias ---- */
.arb-barra {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 12px;
    margin-bottom: 16px;
    background: #f7f9fb;
    border: 1px solid #e6e9ef;
    border-radius: 4px;
}

.arb-barra button {
    border: 1px solid #dde2e9;
    background: #fff;
    border-radius: 3px;
    padding: 6px 13px;
    font-size: 0.82em;
    color: #4a5765;
}

.arb-barra button:hover {
    border-color: #009982;
    color: #009982;
}

.arb-barra button[aria-current="true"] {
    background: #009982;
    border-color: #009982;
    color: #fff;
    font-weight: 600;
}

.arb-barra .sep {
    margin-left: auto;
}

/* ---------------------------------------------------------------------------
   Casilla de las de baja

   Sin caja y mas pequena que las pestanas: cambia lo que se mira, no es una de
   las familias. Se queda en gris de texto en los tres estados y solo engorda al
   marcarla; el turquesa esta reservado para la familia que esta puesta, y si lo
   usara tambien la casilla pareceria una pestana mas.

   El hueco a su izquierda la separa del grupo de familias sin sacarla de la
   barra: es un filtro sobre ellas, no una cuarta opcion.
   --------------------------------------------------------------------------- */
.arb-barra .chk-baja {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 0 0 0 12px;
    font-size: 0.78em;
    font-weight: 400;
    color: #7b8794;
    cursor: pointer;
    user-select: none;
}

.arb-barra .chk-baja input {
    margin: 0;
    cursor: pointer;
}

.arb-barra .chk-baja:hover {
    color: #4a5765;
}

/* Va despues y con la misma especificidad, asi que gana: pasar por encima de la
   que ya esta puesta no la aclara. */
.arb-barra .chk-baja.puesto {
    color: #3d4a58;
    font-weight: 600;
}

/* ---- Buscador ----
   Sin caja propia: la lupa y el texto sobre el fondo de la barra, con una linea
   abajo que solo se marca al escribir o al enfocar. Es un filtro mas, y con borde
   completo pesaba mas que las pestanas que tiene al lado. */
.arb-barra .busc {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 2px;
    border-bottom: 1px solid #dde2e9;
    color: #98a2ad;
}

.arb-barra .busc:focus-within {
    border-bottom-color: #009982;
    color: #009982;
}

.arb-barra .busc input {
    width: 150px;
    border: 0;
    background: transparent;
    padding: 0;
    font-size: 0.82em;
    color: #4a5765;
    outline: none;
}

.arb-barra .busc .fa-search {
    font-size: 0.78em;
}

.arb-barra .busc-x {
    border: 0;
    background: transparent;
    padding: 0 2px;
    font-size: 0.78em;
    color: #aab4c0;
}

.arb-barra .busc-x:hover {
    background: transparent;
    border: 0;
    color: #a13a2f;
}

.busc-cuenta {
    font-size: 0.78em;
    color: #98a2ad;
    font-variant-numeric: tabular-nums;
}

.arb-barra .cnt {
    font-variant-numeric: tabular-nums;
    opacity: 0.75;
}

/* El alta va en la barra y no en la tabla: es lo unico que se hace aqui, y en la
   barra esta a la misma altura que el filtro y las familias. Lleva el verde de
   accion; las pestanas llevan turquesa de "puesta", que no es lo mismo.

   La regla es `.arb-barra .btn-nueva` y no `.btn-nueva` a secas porque
   `.arb-barra button` tiene mas especificidad y le ganaria el fondo blanco. */
.arb-barra .btn-nueva {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #009982;
    border: 1px solid #009982;
    color: #fff;
    font-weight: 600;
    padding: 6px 13px;
}

/* Un pelo mas pequeno que el texto: acompana al rotulo, no compite con el. */
.arb-barra .btn-nueva .fa-plus {
    font-size: 0.92em;
}

.arb-barra .btn-nueva:hover {
    background: #00806d;
    border-color: #00806d;
    color: #fff;
}

/* ---- Tabla ---- */
.sector-tabla {
    width: 100%;
    margin-bottom: 0;
    border-collapse: collapse;
}

.sector-tabla thead th {
    background: #2c3e50;
    color: #fff;
    border: 0;
    padding: 11px 18px;
    font-size: 0.76em;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    white-space: nowrap;
    text-align: left;
}

.sector-tabla tbody tr {
    border-bottom: 1px solid #eef1f5;
}

.sector-tabla tbody tr:last-child {
    border-bottom: 0;
}

.sector-tabla tbody td {
    padding: 12px 18px;
    border: 0;
    vertical-align: middle;
}

.sector-tabla tbody tr:nth-child(even) td {
    background: #fcfdfe;
}

.sector-tabla tbody tr:hover td {
    background: rgba(0, 153, 130, 0.08);
}

.sector-tabla th.num,
.sector-tabla td.num {
    text-align: right;
    white-space: nowrap;
    width: 130px;
}

.sector-tabla td.num {
    font-variant-numeric: tabular-nums;
    color: #3d4a58;
}

/* El ancho y el corte de linea van en las dos filas; el gris y el tamano menor,
   solo en el cuerpo. En la cabecera pisaban al blanco de `thead th` -dos clases
   ganan a una clase y dos elementos- y esas dos columnas salian de otro color que
   el resto. */
.sector-tabla th.tipo,
.sector-tabla td.tipo {
    white-space: nowrap;
    width: 140px;
}

.sector-tabla td.tipo {
    color: #7b8794;
    font-size: 0.86em;
}

.sector-tabla th.padre,
.sector-tabla td.padre {
    width: 220px;
}

.sector-tabla td.padre {
    color: #7b8794;
    font-size: 0.86em;
}

.padre-ninguno {
    color: #c3cbd5;
}

/* Un padre que no resuelve es el sintoma de la etiqueta que no se ve: se dice el
   code para poder buscarlo, y en ambar para que no pase por un nombre. */
.padre-roto {
    color: #96690f;
    font-style: italic;
}

.sector-tabla th.acc,
.sector-tabla td.acc {
    text-align: center;
    white-space: nowrap;
    width: 92px;
}

/* ---- Botones de accion de la fila ---- */
.arb-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    padding: 0;
    margin: 0 2px;
    border: 1px solid transparent;
    border-radius: 3px;
    background: transparent;
    font-size: 0.86em;
    line-height: 1;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,
        transform 0.15s ease, box-shadow 0.15s ease;
}

.arb-btn:hover:not(:disabled) {
    transform: translateY(-1px);
}

.arb-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

/* El lapiz en ambar: modifica. Mismo criterio que la ficha de producto. */
.arb-btn-editar {
    background: rgba(214, 158, 46, 0.12);
    border-color: rgba(214, 158, 46, 0.25);
    color: #96690f;
}

.arb-btn-editar:hover:not(:disabled) {
    background: #d69e2e;
    border-color: #d69e2e;
    color: #fff;
    box-shadow: 0 2px 6px rgba(214, 158, 46, 0.35);
}

.arb-btn-borrar {
    background: rgba(161, 58, 47, 0.1);
    border-color: rgba(161, 58, 47, 0.22);
    color: #a13a2f;
}

.arb-btn-borrar:hover:not(:disabled) {
    background: #a13a2f;
    border-color: #a13a2f;
    color: #fff;
    box-shadow: 0 2px 6px rgba(161, 58, 47, 0.3);
}

.arb-btn-ver {
    background: rgba(0, 153, 130, 0.1);
    border-color: rgba(0, 153, 130, 0.2);
    color: #00745f;
}

.arb-btn-ver:hover:not(:disabled) {
    background: #009982;
    border-color: #009982;
    color: #fff;
    box-shadow: 0 2px 6px rgba(0, 153, 130, 0.3);
}

/* Un filo rojo a la izquierda en la fila que esta mal: al ordenar lo roto primero,
   marca donde acaba el bloque de problemas sin pintar la fila entera de color. */
.sector-tabla tbody tr.rota td:first-child {
    box-shadow: inset 3px 0 0 #a13a2f;
}

.cat-nombre {
    font-weight: 600;
}

/* El estado va debajo del nombre y no en una columna propia: es una frase, no un
   dato, y en columna obligaria a recortarla. */
.cat-estado {
    display: block;
    font-size: 0.8em;
    margin-top: 2px;
}

.cat-estado.ok { color: #98a2ad; }
.cat-estado.warn { color: #96690f; }
.cat-estado.mal { color: #a13a2f; font-weight: 600; }

tr.sin-cat td {
    background: #f7f9fb !important;
}

tr.sin-cat .cat-nombre {
    color: #98a2ad;
    font-style: italic;
    font-weight: 400;
}

.vacio {
    padding: 22px 18px;
    text-align: center;
    color: #98a2ad;
    font-size: 0.9em;
    margin: 0;
}

.foot {
    padding-top: 14px;
    color: #98a2ad;
    font-size: 0.84em;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Categorias/EtiquetasNegocio.vue